import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NumberInput } from '@angular/cdk/coercion';
import { environment } from '../../envoirnments/environment';


@Injectable({
  providedIn: 'root'
})

export class ApiServicesService {

  private secretKey = 'HongKong';

  // Server
  apiUrl = environment.baseUrl;
  frontendAssetsUrl = environment.baseUrl+'member/assets/';

  // Local
  // apiUrl = 'http://localhost:3070/';
  // frontendAssetsUrl = 'http://localhost:4200/assets/';

  dynamicUserauth!: any;
  private readonly registerUrl = `${this.apiUrl}api/users/register`;
  private readonly loginUrl = `${this.apiUrl}api/users/login`;
  private readonly forgotpwdUrl = `${this.apiUrl}api/otp/forgot-password-send-otp`;

  header: any
  private initializeUserDetails(): void {
    const isBrowser = typeof window !== 'undefined' && typeof localStorage !== 'undefined';
    if (isBrowser) {
      const encryptedData = localStorage.getItem('encryptedUserData');
      if (encryptedData) {
        const decryptedData = this.decryptData(encryptedData);
        if (decryptedData && decryptedData.user) {
          this.dynamicUserauth = decryptedData.user.token;
          this.header = {
            headers: new HttpHeaders({
              Authorization: `Bearer ${this.dynamicUserauth}`,
            })
          };
        } else {
          console.error('Failed to decrypt or find user data.');
        }
      } else {
        console.warn('No encrypted data found in localStorage.');
      }
    } else {
      console.warn('localStorage is not available in this environment.');
    }
  }

  encryptData(data: any): string {
    return CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
  }

  decryptData(data: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(data, this.secretKey);
      if (bytes.toString()) {
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  // ------------view profile api-------------------
  constructor(private http: HttpClient) {
    this.initializeUserDetails();
  }

  getUserProfile(userName: string): Observable<any> {
    const url = `${this.apiUrl}api/profile/my-profile?username=${userName}`;
    return this.http.get(url, this.header);
  }

  viewOthersProfile(userName: string): Observable<any> {
    const url = `${this.apiUrl}api/profile/view-others-profile?username=${userName}`;
    return this.http.get(url, this.header);
  }

  sendFriendRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/send-friend-request`;
    return this.http.post(url, data, this.header);
  }

  cancelFriendRequest(data: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/unfriend-cancel-request`;
    return this.http.post(url, data, this.header);
  }

  addToFavorite(data: any): Observable<any> {
    const url = `${this.apiUrl}api/favorite/add-favorite`;
    return this.http.post(url, data, this.header);
  }

  blockUser(data: any): Observable<any> {
    const url = `${this.apiUrl}api/block/block-user`;
    return this.http.post(url, data, this.header);
  }

  getDropdowndata(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-dropdown-options`;
    return this.http.get(url, this.header);
  }

  filterDropdowndata(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-list-member-dropdown-filters`;
    return this.http.get(url, this.header);
  }



  getAdvanceDropdowndata(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-advanced-search-dropdown-options`;
    return this.http.get(url, this.header);
  }


  getQuickDropdowndata(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-quick-search-dropdown-options`;
    return this.http.get(url, this.header);
  }

  updateProfilePicture(data: FormData): Observable<any> {
    const url = `${this.apiUrl}api/users/update-profile-picture`;
    return this.http.post(url, data, this.header);
  }

  updateProfile(data: FormData): Observable<any> {
    const url = `${this.apiUrl}api/users/update-profile`;
    return this.http.put(url, data, this.header);
  }

  updateCoverProfile(data: FormData): Observable<any> {
    const url = `${this.apiUrl}api/users/update-cover-picture`;
    return this.http.post(url, data, this.header);
  }

  countryDropdown(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-country`;
    return this.http.get(url, this.header);
  }

  getGenders(): Observable<any> {
    const url = `${this.apiUrl}api/dropdown/get-gender`;
    return this.http.get<any>(url);
  }
  getStatesByCountry(countryId: any): Observable<any> {
    const params = new HttpParams()
      .set('countryId', countryId);
    return this.http.get<any>(`${this.apiUrl}api/dropdown/get-state`, { params });
  }
  getCity(stateId: any): Observable<any> {
    const params = new HttpParams()
      .set('stateId', stateId);
    return this.http.get<any>(`${this.apiUrl}api/dropdown/get-city`, { params });

  }

  registerUser(formData: [{
    username: string;
    gender: string;
    first_name: string;
    last_name: string;
    email: string;
    dob: string;
    otp:any
  }]): Observable<any> {
    return this.http.post<any>(this.registerUrl, formData);
  }

  getCItyByStates(stateId: any) {
    const url = `${this.apiUrl}api/dropdown/get-city?stateId=${stateId}`;
    return this.http.get(url, stateId);
  }

  getSuguser(): Observable<any> {
    const url = `${this.apiUrl}api/suggestion/get-suggested-profile`;
    return this.http.get(url, this.header);
  }

  // sendFriendRequest(friend_id: any): Observable<any> {
  //   const url = `${this.apiUrl}api/friends/send-friend-request`;
  //   return this.http.post(url, {friend_id:friend_id}, this.header);
  // }

  acceptSugUser(friend_id: any): Observable<any> {
    const url = `${this.apiUrl}api/suggestion/accept-suggested-user`;
    return this.http.post(url, { targetUserId: friend_id }, this.header);
  }

  ignoreSugUser(friend_id: any): Observable<any> {
    const url = `${this.apiUrl}api/suggestion/ignore-suggestion`;
    return this.http.post(url, { flaggedUserId: friend_id }, this.header);
  }

  getPendingRequest(page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/get-pending-friend-requests?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }
  acceptFriendrequest(friend_id: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/accept-friend-request`;
    return this.http.post(url, { targetUserId: friend_id }, this.header);
  }

  rejectFriendrequest(friend_id: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/reject-friend-request`;
    return this.http.post(url, { targetUserId: friend_id }, this.header);
  }

  getFriendList(targetUserId: any, page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/get-friend-list?page=${page}&limit=${limit}&targetUserId=${targetUserId}`;
    return this.http.get(url, this.header);
  }

  getPhotos(targetUserId: any, albumId: any, page: any, limit: any,): Observable<any> {
    let url = `${this.apiUrl}api/album/get-photos?page=${page}&limit=${limit}&targetUserId=${targetUserId}`;
    if (albumId) {
      url += `&albumId=${albumId}`;
    }
    return this.http.get(url, this.header);
  }

  uploadPhotos(formData: any): Observable<any> {
    const url = `${this.apiUrl}api/album/upload-photos`;
    return this.http.post(url, formData, this.header);
  }


  getFavusers(targetUserId: any, page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/favorite/get-favorite-users?page=${page}&limit=${limit}&targetUserId=${targetUserId}`;
    return this.http.get(url, this.header);
  }

  removeFavuser(favUser: any): Observable<any> {
    const url = `${this.apiUrl}api/favorite/remove-favorite?favoriteUserId=${favUser}`;
    return this.http.delete(url, this.header);
  }


  createAlbum(data: any): Observable<any> {
    const url = `${this.apiUrl}api/album/create-album`;
    return this.http.post(url, data, this.header);
  }

  EditAlbum(data: any, album_id: any): Observable<any> {
    const url = `${this.apiUrl}api/album/update-album?albumId=${album_id}`;
    return this.http.put(url, data, this.header);
  }

  getAllalbum(user_id: any, page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/album/get-album?targetUserId=${user_id}&page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  deleteAlbum(album_id: any): Observable<any> {
    const url = `${this.apiUrl}api/album/delete-album?albumId=${album_id}`;
    return this.http.delete(url, this.header);
  }

  checkProfile(userName: String) {
    const encryptedData = localStorage.getItem('encryptedUserData');
    if (encryptedData) {
      const decryptedData = this.decryptData(encryptedData);
      if (decryptedData && decryptedData.user) {
        return decryptedData.user.username == userName;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  Viewed(page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/profile/profiles-i-viewed?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  ViewedMe(page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/profile/profiles-viewed-me?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  blockUsers(page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/block/get-blocked-users?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }


  unblock(block_id: any): Observable<any> {
    const url = `${this.apiUrl}api/block/unblock-user`;
    return this.http.post(url, { userIdToUnblock: block_id }, this.header);
  }

  reserPass(email: any, newPass: any): Observable<any> {
    const url = `${this.apiUrl}api/otp/reset-password`;
    return this.http.put(url, { email: email, password: newPass }, this.header);
  }
  loginUser(username:any,otp:any): Observable<any> {
    return this.http.post<any>(this.loginUrl, {username:username,otp:otp});
  }

  sendloginOtp(username:any): Observable<any> {
    let url = `${this.apiUrl}api/otp/send-otp-login`;
    return this.http.post<any>(url, {email:username});
  }


  

  // sendRegOtp(formval): Observable<any> {
  //   let url = `${this.apiUrl}api/otp/send-otp-register`;
  //   return this.http.post<any>(url, {username:username,email:email,gender:gender,type:type});
  // }


  sendRegOtp(formData: [{
    username: string;
    gender: string;
    first_name: string;
    last_name: string;
    email: string;
    dob: string;
  }]): Observable<any> {
    let url = `${this.apiUrl}api/otp/send-otp-register`;
    return this.http.post<any>(url, formData);
  }


  checkOTP(email: string,
    otp: any,type:any): Observable<any> {
    const params = new HttpParams()
      .set('email', email).set('otp', otp);
    return this.http.post<any>(`${this.apiUrl}api/otp/check-otp`, null, { params });
  }


  newpassword(email: string, password: any): Observable<any> {
    const data = { email, password };
    return this.http.put<any>(`${this.apiUrl}api/otp/reset-password`, data);
  }







  loadMembers(page: number,
    username: string | null = null,
    seeking_gender: string | null = null,
    country: string | null = null,
    state: string | null = null,
    city: string | null = null,
    age_from: number | null = null,
    age_to: number | null = null,
    isOnline: false,
    limit: number | null = null): Observable<any> {
    let url = `${this.apiUrl}api/profile/get-user-list`;

    let ageRange: string | null = null;
    if (age_from && age_to) {
      ageRange = `${age_from}-${age_to}`;
    } else if (age_from && !age_to) {
      ageRange = `${age_from}+`;
    } else if (!age_from && age_to) {
      ageRange = `0-${age_to}`;
    }
    return this.http.post(url, { username: username, seeking_gender: seeking_gender, country: country, state: state, city: city, ageRange: ageRange, limit: limit, page: page }, this.header);
  }


  public setheaders() {
    this.initializeUserDetails();
  }

  // searchMembers(
  //   page: number,
  //   gender: string | null = null,
  //   seeking: string | null = null,
  //   country: string | null = null,
  //   state: string | null = null,
  //   city: string | null = null,
  //   age_from: number | null = null,
  //   age_to: number | null = null,
  //   isOnline: false,
  //   pets: string | null = null,
  //   seeking_for: string | null = null,
  //   limit: number | null = null

  // ): Observable<any> {
  //   let url = `${this.apiUrl}api/profile/get-user-list?page=${page}`;
  //   if (gender) url += `&gender=${gender}`;
  //   if (seeking) url += `&seeking=${seeking}`;
  //   if (country) url += `&country=${country}`;
  //   if (state) url += `&state=${state}`;
  //   if (city) url += `&city=${city}`;
  //   if (age_from && age_to) url += `&ageRange=${age_from}-${age_to}`;
  //   url += `&isOnline=${isOnline}`;
  //   // if (pets) url += `&pets=${pets}`;
  //   // if (seeking_for) url += `&seeking_for=${seeking_for}`;
  //   if (limit) url += `&limit=${limit}`;

  //   return this.http.get(url, this.header);
  // }


  searchMembers(
    page: number,
    gender: string | null = null,
    seeking_gender: string | null = null,
    country: string | null = null,
    state: string | null = null,
    city: string | null = null,
    age_from: number | null = null,
    age_to: number | null = null,
    isOnline: boolean | null = null,
    pets: string | null = null,
    seeking_for: string | null = null,
    limit: number | null = null
  ): Observable<any> {
    let url = `${this.apiUrl}api/profile/get-user-list`;
  
    let ageRange: string | null = null;
    if (age_from !== null && age_to !== null) {
      ageRange = `${age_from}-${age_to}`;
    } else if (age_from !== null) {
      ageRange = `${age_from}+`;
    } else if (age_to !== null) {
      ageRange = `0-${age_to}`;
    }
    // console.log('isOnline',isOnline)
  
    // Construct the payload
    const payload: Record<string, any> = {}; // Allow dynamic property assignment
  
    const params = {
      gender,
      seeking_gender,
      country,
      state,
      city,
      ageRange,
      pets,
      seeking_for,
      limit,
      page,
      isOnline,
    };
  
    // Only include non-null and non-empty values in the payload
    (Object.keys(params) as Array<keyof typeof params>).forEach((key) => {
      if (params[key] !== null && params[key] !== '' && params[key] !== undefined) {
        payload[key] = params[key];
      }
    });
  
    return this.http.post(url, payload, this.header);
  }
  



  public removeheaders() {
    this.header = {};
  }

  deletePhotos(photoId: any, albumId: any): Observable<any> {
    let url = `${this.apiUrl}api/album/delete-photos?photoId=${photoId}`;
    if (albumId) {
      url += `&albumId=${albumId}`;
    }
    return this.http.delete(url, this.header);
  }

  getAllPost(targetUserId: any, page: any, limit: any): Observable<any> {
    let url = `${this.apiUrl}api/post/get-posts?targetUserId=${targetUserId}&page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  getAllPostActivity(page: any, limit: any): Observable<any> {
    let url = `${this.apiUrl}api/post/get-activity?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  CreatePost(textMessages: any): Observable<any> {
    let url = `${this.apiUrl}api/post/create-text-post`;
    return this.http.post(url, { textMessages: textMessages }, this.header);
  }

  recordProfileView(data: any): Observable<any> {
    let url = `${this.apiUrl}api/profile/record-profile-view`;
    return this.http.post(url, data, this.header);
  }

  SendMsg(targetId: any, subject: any, body: any, draftId:any): Observable<any> {
    let url = `${this.apiUrl}api/message/create-message`;
    return this.http.post(url, { targetuserID: targetId, subject: subject, body: body, draftId:draftId }, this.header);
  }


  SendConMsg(conversationId: any, targetId: any, body: any, subject: any,draftId:any): Observable<any> {
    let url = `${this.apiUrl}api/message/create-message`;
    return this.http.post(url, { conversationId: conversationId, targetuserID: targetId, body: body,draftId:draftId,subject:subject  }, this.header);
  }

  saveMsg(
    targetId: any,
    subject: any,
    body: any,
    draftID: any,
    conversationID: any
  ): Observable<any> {
    const url = `${this.apiUrl}api/message/create-update-draft`;
  
    // Dynamically construct the payload
    const payload: any = {};
    if (targetId) payload.targetuserID = targetId;

    if (subject) payload.subject = subject; // Only add subject if conversationID is not present
    if (body) payload.body = body;
    if (draftID) payload.draftID = draftID;
    if (conversationID) payload.conversationID = conversationID;
  
    // Send the request
    return this.http.put(url, payload, this.header);
  }
  


  getDraftMsg(page: any, limit: any) {
    let url = `${this.apiUrl}api/message/list-draft?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  getInboxMsg(page: any, limit: any) {
    let url = `${this.apiUrl}api/message/inbox?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }


  getSendMsg(page: any, limit: any) {
    let url = `${this.apiUrl}api/message/sent?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }


  getInsideInboxMsg(conversationId: any, page: any, limit: any) {
    let url = `${this.apiUrl}api/message/conversation?conversationID=${conversationId}&page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }


  getInsideDeleteMsg(conversationId: any, page: any, limit: any) {
    let url = `${this.apiUrl}api/message/get-deleted-conversation-messages?conversationID=${conversationId}&page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  getCombinedList(page: any, limit: any): Observable<any> {
    const url = `${this.apiUrl}api/friends/get-combined-friend-favorite-list?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  deleteConMsg(conversationIDs: any): Observable<any> {
    const url = `${this.apiUrl}api/message/delete-conversation`;
    return this.http.post(url, { conversationIDs: conversationIDs }, this.header);
  }


  getDeleted(page: any, limit: any) {
    let url = `${this.apiUrl}api/message/get-delete-conversation-list?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }

  deleteSendMsg(conversationIDs: any): Observable<any> {
    const url = `${this.apiUrl}api/message/delete-message`;
    return this.http.post(url, { messageIDs: conversationIDs }, this.header);
  }


  logout(): Observable<any> {
    const url = `${this.apiUrl}api/users/logout`;
    return this.http.post(url, '', this.header);
  }

  getPrivacySettings() {
    let url = `${this.apiUrl}api/privacy-setting/get-privacy-setting-options`;
    return this.http.get(url, this.header);
  }


  getPrivacySettingsDatas() {
    let url = `${this.apiUrl}api/privacy-setting/privacy-settings`;
    return this.http.get(url, this.header);
  }



  update_privacy(viewPictures: any, viewFriends: any): Observable<any> {
    let url = `${this.apiUrl}api/privacy-setting/update-privacy-settings`;
    return this.http.put(url, { viewPictures: viewPictures, viewFriends: viewFriends }, this.header);
  }


  getOnlineUsers(page: any, limit: any) {
    let url = `${this.apiUrl}api/online/get-online-users?page=${page}&limit=${limit}`;
    return this.http.get(url, this.header);
  }



  deleteDraftMsg(draftID: any): Observable<any> {
    const url = `${this.apiUrl}api/message/delete-draft-messages`;
    return this.http.post(url, { draftID: draftID }, this.header);
  }

  deleteDelMsg(conversationIDs: any): Observable<any> {
    const url = `${this.apiUrl}api/message//hard-delete-conversations`;
    return this.http.post(url, { conversationIds: conversationIDs }, this.header);
  }

  updateEmail(newEmail: any): Observable<any> {
    const url = `${this.apiUrl}api/users/update-email`;
    return this.http.put(url, { newEmail: newEmail }, this.header);
  }


  getCounts(): Observable<any> {
    const url = `${this.apiUrl}api/users/get-message-request-count`;
    return this.http.get(url,this.header);
  }


}


